import styles from './sales.module.css';

type Props = {
    reviews: reviewProps[]
}

type reviewProps = {
    company: string,
    description: string,
    author: string,
    reviewerDetail: string,
    logo: string
}

const Reviews = ({ reviews }: Props) => (
    <div className={styles.reviews}>
        <h2>What our clients say</h2>
        {reviews.map((review, i) => (
            <div key={review.author} className={reviews.length > 2 ? styles.col3 : styles.col2} >
                <img src={`${process.env.NEXT_PUBLIC_APP_CDN_URL}${review.logo}`} alt={review.company} />
                <p className={styles.review}>{review.description}</p>
                <p className={styles.reviewer}>{review.author}</p>
                <p className={styles.reviewerDetail}>{review.reviewerDetail}</p>
            </div>
        ))}

    </div>
);

export default Reviews;